import { render, staticRenderFns } from "./outposts.vue?vue&type=template&id=39658832"
import script from "./outposts.vue?vue&type=script&lang=js"
export * from "./outposts.vue?vue&type=script&lang=js"
import style0 from "./outposts.vue?vue&type=style&index=0&id=39658832&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports